import { Button } from 'components/basics';
import { colors, textBold } from 'styles';
import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import Markdown from 'utils/markdownToComponent';
import { breakpoint } from 'utils/mediaQueries';
import { Grid, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const StyledMarkdown = styled(Markdown)`
  font-family: ${props => `${props.theme.typography.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};
  ${breakpoint.down('lg')`
  font-size: ${props => `${props.theme.typography.body2.fontSize}px`}`}
  ${breakpoint.down('md')`padding-top:2rem`}
`;

const Title = styled(Typography)`
  ${textBold};
  ${breakpoint.down('lg')`
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`}`}
`;
const Container = styled(Grid)`
  text-align: center;
`;
const StyledLink = styled.a`
  text-decoration: none;
  color: ${colors.white};
`;

const BlogBlock = ({ data }) => {
  return (
    <Container item xs={12} sm={8} md={10} lg={10}>
      <Title variant="h6">{data.frontmatter.title}</Title>
      <StyledMarkdown>{data.rawMarkdownBody}</StyledMarkdown>
      <StyledLink rel="noopener" href={data.frontmatter.link} target="_blank">
        <Button
          size="large"
          variant={'contained'}
          customBackgroundColor={colors[data.frontmatter.color]}
          customHoverBackgroundColor={
            colors.shades[data.frontmatter.color].dark
          }
          color="primary"
          mt={1}
        >
          <FormattedMessage id="button.blog" />
        </Button>
      </StyledLink>
    </Container>
  );
};
export default BlogBlock;
